
export const HOTELS_INFO_GET_REQUEST = 'HOTELS_INFO_GET_REQUEST';
export const HOTELS_INFO_GET_SUCCESS = 'HOTELS_INFO_GET_SUCCESS';
export const HOTELS_INFO_GET_ERROR = 'HOTELS_INFO_GET_ERROR'; 

export const HOTELS_DETAILS_GET_REQUEST = 'HOTELS_DETAILS_GET_REQUEST';
export const HOTELS_DETAILS_GET_SUCCESS = 'HOTELS_DETAILS_GET_SUCCESS';
export const HOTELS_DETAILS_GET_ERROR = 'HOTELS_DETAILS_GET_ERROR';